import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import LandingPage from './pages/LandingPage'
import PlayerPage from './pages/PlayerPage'
import Player2 from './pages/Player2'
import SurveyPage from './pages/SurveyPage'
import CompletionPage from './pages/CompletionPage'
import ErrorPage from './pages/ErrorPage'
import AdminDashboard from './pages/AdminDashboard'
import DatabaseManagement from './pages/DatabaseManagement'
import TestPage from './pages/TestPage'
import LoadTestPage from './pages/LoadTestPage'
import DebugPage from './pages/DebugPage'
import './App.css'

function App() {
  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/player" element={<PlayerPage />} />
          <Route path="/player2" element={<Player2 />} />
          <Route path="/survey" element={<SurveyPage />} />
          <Route path="/completion" element={<CompletionPage />} />
          <Route path="/error" element={<ErrorPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/database" element={<DatabaseManagement />} />
          <Route path="/test" element={<TestPage />} />
          <Route path="/loadtest" element={<LoadTestPage />} />
          <Route path="/debug" element={<DebugPage />} />
          {/* Catch all route for 404s */}
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </div>
    </Router>
  )
}

export default App
